import { useEffect } from "react";

export function useTrackPageView() {
    useEffect(() => {
        const SID_KEY = "deg_sid";
        let sid = sessionStorage.getItem(SID_KEY);
        if (!sid) {
            sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
            sessionStorage.setItem(SID_KEY, sid);
        }
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                session_id: sid,
                path: window.location.pathname,
                referrer: document.referrer || "",
            }),
        }).catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
